
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/collections/CollectionDesc",
      function () {
        return require("private-next-pages/collections/CollectionDesc.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/collections/CollectionDesc"])
      });
    }
  